export default __webpack_public_path__ + "static/media/mediation_icon.dbede3ed.webp";